import { AxiosResponse } from 'axios';
import API from 'src/services/api';
import { FilesData } from 'src/components/FilesList/types';
import {FilesOption, UpdateExpireDateOptions} from './types';
const filesApi = {

  async fetchOptions(): Promise<AxiosResponse<FilesData>> {
    return await API.options('/files');
  },

  async fetchFiles(params: FilesOption = {}, options: { signal?: AbortSignal } = {}): Promise<AxiosResponse<FilesData>> {
    const { mimetypes, name, ...restParams } = params;
    let url = '/files';

    const urlParams: {[index: string]: string} = {};
    if (mimetypes?.length) urlParams['mimetypes'] = JSON.stringify(mimetypes);
    if (name?.length) urlParams['name'] = name;

    if (Object.keys(urlParams).length) {
      url += `?${new URLSearchParams(urlParams).toString()}`;
    }

    return await API.get(url, {
      params: restParams,
      signal: options.signal,
    });
  },
  async updateFileRequest(params: UpdateExpireDateOptions): Promise<AxiosResponse<FilesData>> {
    const url = `/files/${params.id}/${params.propertyName}`;
    const config = { headers: {'Content-Type': 'text/plain'} };
    return await API.put(url, params.date, config);
  },
  async deleteFile(id: string): Promise<AxiosResponse<FilesData>> {
    return await API.delete(`/files/${id}`);
  },
};

export default filesApi;
